import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { QuestionnaireAnswers } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class RefillResponsesEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  get(visitId: string | number): Observable<QuestionnaireAnswers.RefillAnswersResponse[]> {
    return this.http
      .get<
        QuestionnaireAnswers.RefillAnswersResponse[]
      >(`${this.env.constants.ADMIN_API_URL}/admin/orders/${visitId}/refillresponses`)
      .pipe(catchError((err: HttpErrorResponse) => throwError(() => new Error(err.message))));
  }
}
